





















import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { NoSSR, UiObserveVisibility } from '@jtnews/shared/ui';
import { waitingFor } from '../../../../shared/utils';
import { useStore } from 'vuex-simple';

@Component({
  name: 'RelapBlock',
  components: {
    NoSSR,
    UiObserveVisibility
  }
})
export default class RelapBlock extends Vue {
  @Prop({
    type: String,
    default: ''
  })
  partnerId: string;

  store = useStore(this.$store);

  get isMobile () {
    return this.store.deviceInfo.isMobile;
  }

  @Emit('viewAdv')
  emitView() {
    return 'relap';
  }

  @Emit('clickAdv')
  emitClick() {
    return 'relap';
  }

  handleVisible () {
    if (!this.isMobile) {
      this.emitView();
    }
  }

  mounted () {
    waitingFor({
      name: `relap-${this.partnerId}-init`,
      callback: () => 'relapAPI' in window,
      interval: 100,
    }).then(() => {
      const { relapAPI } = window as any;

      relapAPI.addGlobalEventListeners({
          onFollow: (e: any) => {
              if (e.el === this.$el.querySelector('.js-relap-widget-wrapper')) {
                  this.emitClick();
              }
          },

          // TODO понять почему обсервер не срабатывает на мобилке и приходится юзать API релапа
          onShow: (e: any) => {
            if (this.isMobile && e.el === this.$el.querySelector('.js-relap-widget-wrapper')) {
              this.emitView();
            }
          }
      });
    });
  }
}
